import * as Popover from '@radix-ui/react-popover';
import React from 'react';
import Dropdown, { IOption } from '../Dropdown/Dropdown';
import { Ellipsis } from '../../assets/icons/Ellipsis';
import IconButton, { IconButtonProps } from '../IconButton/IconButton';
import styles from './EllipsisMenu.module.scss';

export interface IEllipsisMenuProps {
  options: IOption[];
  variant?: IconButtonProps['variant'];
  colour?: IconButtonProps['colour'];
  disabled?: boolean;
}

const EllipsisMenu = ({ options, variant = 'solid', colour = 'blueberry', disabled = false }: IEllipsisMenuProps) => {
  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <IconButton
          aria-label="ellipsis menu button"
          onClick={(event) => event.stopPropagation()}
          variant={variant}
          colour={colour}
          disabled={disabled}
          aria-disabled={disabled}
        >
          <Ellipsis />
        </IconButton>
      </Popover.Trigger>
      {options.length > 0 && (
        <Popover.Portal>
          <Popover.Content className={styles['popover-content']} align="end" sideOffset={4}>
            <Dropdown options={options} isOpen={true} />
          </Popover.Content>
        </Popover.Portal>
      )}
    </Popover.Root>
  );
};

export default EllipsisMenu;
